import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import ICONS from 'src/constants/icons';
import styles from './styles.module.scss';

@observer
class ActionModalDetailWarning extends React.Component {
  render() {
    return (
      <div className={styles.container}>
        <div className={styles.title}>
          <img className={styles.icon} src={this.props.icon} alt="warning" />
          <div className={styles.label}>{this.props.title}</div>
        </div>

        <div className={styles.content}>
          {this.props.content}
        </div>
      </div>
    );
  }
}

ActionModalDetailWarning.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  content: PropTypes.string
};

ActionModalDetailWarning.defaultProps = {
  icon: ICONS.warning,
  title: '',
  content: ''
};

export default ActionModalDetailWarning;
